import $ from 'jquery';

function addAlert(message, focus = false) {
  $('#tn-alert-message-template').clone()
    .attr('id', null)
    .attr('name', 'tn-alert-message')
    .attr('class', 'tn-heading-info')
    .html(message)
    .insertAfter('#tn-alert-message-template')
    .show(100);

  if (focus) {
    focusUserOnMessages();
  }
}

function addError(errorMessage, focus = false) {
  $('#tn-error-message-template').clone()
    .attr('id', null)
    .attr('name', 'tn-error-message')
    .attr('class', 'bg-danger alert tn-heading-error')
    .html(errorMessage)
    .insertAfter('#tn-error-message-template')
    .show(100);

  if (focus) {
    focusUserOnMessages();
  }
}

function clearAlerts() {
  const $el = $("[name='tn-alert-message']");
  $el.hide(100, () => {
    $el.remove();
  });
}
function clearErrors() {
  const $el = $("[name='tn-error-message']");

  $el.hide(100, () => {
    $el.remove();
  });
}


function focusUserOnMessages() {
  const $el = $('#tn-error-message-template');
  const scrollTop = `${$el.offset().top - 10}px`;

  $('html, body').animate({ scrollTop }, 'fast');
}

function clear() {
  clearAlerts();
  clearErrors();
}


export default {
  addAlert,
  addError,
  clearAlerts,
  clearErrors,
  focusUserOnMessages,
  clear,
};



// WEBPACK FOOTER //
// ./V7/tnew/ui/Messaging.js